import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { IonicModule, ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';

/**
 *  A TANÉV RENDJÉRŐL SZÓLÓ RENDELET BEEMELÉSE (backend: tanevrendje-rendelet.js, app.js).
 *
 *  A minisztérium évente rendeletben adja ki a tanév rendjét (2026/2027: 1/2026. OGYM rendelet). Egy
 *  gombnyomással beolvassuk az njt-ről, előnézetben megmutatjuk a kiolvasott bejegyzéseket – a már
 *  felvitteket és az intézményre nem vonatkozókat jelölve, alapból kihagyva –, és a kiválasztottakat
 *  a naptárba emeljük (a szünetek a tanügyi naptárba is), kérésre a tanév határaival együtt.
 */
@Component({
  standalone: true,
  imports: [IonicModule, CommonModule, FormsModule],
  selector: 'app-tanevrendje-rendelet-modal',
  templateUrl: './tanevrendje-rendelet-modal.component.html',
  styleUrls: ['./tanevrendje-rendelet-modal.component.scss'],
})
export class TanevrendjeRendeletModalComponent implements OnInit {
  @Input() intezmeny = '';

  tanev = new Date().getMonth() >= 6 ? new Date().getFullYear() : new Date().getFullYear() - 1;
  tanevek: number[] = [];
  njt = '';
  toltodik = false;
  fut = false;
  hiba = '';
  elonezet: any = null;
  valasztott: Record<string, boolean> = {};
  tanevHatarok = true;
  kesz: any = null;

  readonly tipusNev: Record<string, string> = { szunet: 'Szünet', egyeb: 'Egyéb', meres: 'Mérés', program: 'Program' };

  constructor(private http: HttpClient, private modalCtrl: ModalController) {}

  ngOnInit() {
    this.tanevek = [this.tanev - 1, this.tanev, this.tanev + 1];
    this.beolvas();
  }

  async beolvas() {
    this.toltodik = true; this.hiba = ''; this.elonezet = null; this.kesz = null;
    try {
      const p = new URLSearchParams({ tanev: String(this.tanev) });
      if (this.njt.trim()) p.set('njt', this.njt.trim());
      this.elonezet = await firstValueFrom(this.http.get(`/api/tanevrendje/rendelet/elonezet/${this.intezmeny}?${p}`));
      this.valasztott = Object.fromEntries((this.elonezet?.esemenyek || []).map((e: any) => [e.kulcs, !!e.ajanlott]));
      this.tanevHatarok = !!this.elonezet?.jelenlegi;
    } catch (e: any) { this.hiba = e?.error?.error || 'A rendelet nem olvasható be.'; }
    this.toltodik = false;
  }

  get kijeloltDb() { return Object.values(this.valasztott).filter(Boolean).length; }
  get hatarValtozik() {
    const j = this.elonezet?.jelenlegi; const t = this.elonezet?.tanev;
    return !!(j && t && (j.tankezd !== t.elso || j.tanvege !== t.utolso || (t.felev && j.felev !== t.felev)));
  }

  async beemel() {
    this.fut = true; this.hiba = '';
    try {
      this.kesz = await firstValueFrom(this.http.post(`/api/tanevrendje/rendelet/beemel/${this.intezmeny}`, {
        tanev: this.tanev, njt: this.njt.trim() || this.elonezet?.rendelet?.azon,
        kulcsok: Object.entries(this.valasztott).filter(([, v]) => v).map(([k]) => k),
        tanevHatarok: this.tanevHatarok && this.hatarValtozik,
      }));
    } catch (e: any) { this.hiba = e?.error?.error || 'A beemelés nem sikerült.'; }
    this.fut = false;
  }

  bezar() { this.modalCtrl.dismiss({ valtozott: !!this.kesz?.letrehozva || !!this.kesz?.tanev_frissitve }); }
}
